import { render, staticRenderFns } from "./RoleListTableAction.vue?vue&type=template&id=22cacab3&scoped=true"
import script from "./RoleListTableAction.vue?vue&type=script&lang=js"
export * from "./RoleListTableAction.vue?vue&type=script&lang=js"
import style0 from "./RoleListTableAction.vue?vue&type=style&index=0&id=22cacab3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cacab3",
  null
  
)

export default component.exports